import { Component } from '@angular/core';
import {DSA} from '../DSAalgorithm/DSA';

@Component({

  selector: 'signature',
  templateUrl: 'signature.component.html',
  styleUrls: ['signature.component.scss']
})
export class SignatureComponent {
  message: string;
  privateKey: string;
  openKey: string;
  signR: string;
  signS: string;
  


  getSignature():void{
    const dsa = new DSA();
    var sign =  dsa.getSignature(this.message, this.privateKey);
    this.openKey = sign.getStingOpenKey();
    this.signR = sign.getStingR();
    this.signS = sign.getStingS();
    console.log('ok');}
}
